import { render } from "./userbatchImei.vue?vue&type=template&id=4e59b7b4&ts=true"
import script from "./userbatchImei.vue?vue&type=script&lang=ts"
export * from "./userbatchImei.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__